export default __webpack_public_path__ + "static/media/lucky-spin-cn.06669f52.gif";